<app-mobilenav *ngIf="!(router.url == '/general/login' || router.url.startsWith('/mobilepay') || router.url == '/general/nodes' )" class="d-black d-md-none" > </app-mobilenav>
<app-sidebar *ngIf="!(router.url == '/general/login' || router.url.startsWith('/mobilepay') || router.url == '/general/nodes' )" class="d-none d-md-block" [isExpanded]="sidebarExpanded" (toggleSidebar)="sidebarExpanded = !sidebarExpanded"></app-sidebar>


  <div  class = "content" [ngClass]="{ 'sidebarExpanded': sidebarExpanded }">
    <router-outlet></router-outlet>
  </div>
